import { FractionalMoney as PBFractionalMoney } from "gen/proto/money/models_pb"
import { FractionalMoney } from "shared-ts/classes/money"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type FractionalMoneyAccessorFn<T> = TypedAccessor<
  T,
  PBFractionalMoney | undefined
>
type FractionalMoneyColumn<T> = Omit<
  DataColumn<T>,
  "type" | "renderCell" | "width"
> & {
  width?: TableCellWidth
}
export type FractionalMoneyColumnHelper<T> = (
  accessorFn: FractionalMoneyAccessorFn<T>,
  col: FractionalMoneyColumn<T>
) => DataColumn<T>

export function fractionalMoney<T>(
  accessorFn: FractionalMoneyAccessorFn<T>,
  col: FractionalMoneyColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return null
      return FractionalMoney.fromPB(value).roundToNearestTenthOfACent().format()
    },
    width: TableCellWidth.Medium,
    ...col,
  })
}
